/**
 * Product Card Add to Cart
 * Handles add to cart functionality for single variant products in product cards
 */

document.addEventListener('DOMContentLoaded', function() {
  // Handle single variant add to cart from product cards
  document.addEventListener('click', function(e) {
    const addToCartBtn = e.target.closest('[data-product-add-to-cart]');
    if (!addToCartBtn) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const variantId = addToCartBtn.getAttribute('data-product-add-to-cart');
    const productTitle = addToCartBtn.getAttribute('data-product-title');
    const originalText = addToCartBtn.textContent;
    
    // Update button state
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding...';
    
    // Add to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => Promise.reject(err));
      }
      return response.json();
    })
    .then(item => {
      // Success feedback
      addToCartBtn.textContent = 'Added!';
      
      // Open cart drawer if it exists
      if (window.cartDrawer) {
        window.cartDrawer.open();
        window.cartDrawer.refreshDrawerContent();
      } else {
        // Fallback: update cart count if no drawer available
        const cartCount = document.querySelector('.cart .cart-items-count');
        if (cartCount) {
          const currentCount = parseInt(cartCount.textContent) || 0;
          cartCount.textContent = currentCount + 1;
        }
      }
      
      // Reset button after delay
      setTimeout(() => {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = originalText;
      }, 2000);
    })
    .catch(error => {
      console.error('Add to cart failed:', error);
      
      // Error feedback
      addToCartBtn.textContent = 'Error - Try Again';
      setTimeout(() => {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = originalText;
      }, 2000);
    });
  });
}); 